// Dawn Cloud Ripple Effect
function addCloudRipple(button) {
  // Remove existing animation
  button.classList.remove('clicked');
  
  // Force reflow to restart animation
  void button.offsetWidth;
  
  // Add animation class
  button.classList.add('clicked');
  
  // Remove after animation completes
  setTimeout(() => {
    button.classList.remove('clicked');
  }, 800);
  
  // Cash register sound
  playDawnClickSound();
}

// Create a single audio instance for reuse
let dawnClickAudio = null;

// function playDawnClickSound() {
//   try {
//     // Create audio instance if it doesn't exist
//     if (!dawnClickAudio) {
//       dawnClickAudio = new Audio('https://cdn.shopify.com/s/files/1/0618/8367/8779/files/sound-effects-library-cash-register-sound.mp3?v=1754674349');
//       dawnClickAudio.preload = 'auto';
//       dawnClickAudio.volume = 0.3; // Adjust volume as needed (0.0 to 1.0)
//     }
    
//     // Reset to beginning and play
//     dawnClickAudio.currentTime = 0;
//     dawnClickAudio.play().catch(e => {
//       // Silent fallback if audio fails (e.g., user hasn't interacted with page yet)
//       console.log('💰 Cha-ching! (audio playback failed)');
//     });
    
//   } catch (e) {
//     // Silent fallback
//     console.log('💰 Cha-ching! (audio not supported)');
//   }
// }

// Auto-attach the effect when the page loads
document.addEventListener('DOMContentLoaded', function() {
  // Find all cloud ripple buttons and attach event listeners
  const cloudButtons = document.querySelectorAll('.btn--cloud-ripple');
  
  cloudButtons.forEach(button => {
    button.addEventListener('click', function() {
      addCloudRipple(this);
    });
  });
});

// Also attach to any dynamically added buttons (for AJAX cart updates)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList') {
      const newButtons = document.querySelectorAll('.btn--cloud-ripple:not([data-cloud-attached])');
      newButtons.forEach(button => {
        button.setAttribute('data-cloud-attached', 'true');
        button.addEventListener('click', function() {
          addCloudRipple(this);
        });
      });
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});